import capitalizeStringUtil from 'utils/string/capitalize'

/**
 * @param  {ProductVariantCollection} productVariant
 */
export default function getLoyaltyTierNameProductVariantUtil (productVariant) {
  let productLoyaltyTierName = productVariant?.lyt_tier
  if (productLoyaltyTierName) {
    productLoyaltyTierName = capitalizeStringUtil(productLoyaltyTierName)
  }
  return productLoyaltyTierName
}
